<template>

    <div class="footerTaber" @click="handleDibu">
        <div class="visual-footer" :style="{ background: isfooter.data.bjColor }">
            <div class="footer-ul">
                <div class="nav-item" v-for="(item, index) in isfooter.data.footerList" :key="index"
                    :style="{ color: index === 0 ? isfooter.data.xzColor : isfooter.data.textColor }">
                    <img :src="item.src" alt="">
                    <p>{{ item.title }}</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
  name: 'footToolbar',
  components: {},
  props: {
    isfooter: Object
  },
  data () {
    return {
    }
  },
  mounted () {
    console.log('哈哈哈哈哈', this.isfooter)
  },
  methods: {
    handleDibu: function () {
      this.$emit('click', this.isfooter)
    }
  }
}
</script>

<style scoped>
.footerTaber {
    width: 100%;
    display: flex;
    background: #fff;
    bottom: 0;
    border-top: 1px solid #efefef;
}

.visual-footer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 64px;
    background: rgb(254, 253, 253);
}

.visual-footer .footer-ul {
    display: flex;
    width: 100%;
    justify-content: space-around;
    align-items: flex-start;
    padding: 5px 0;
}

.visual-footer .nav-item {
    flex: 1;
    text-align: center;
    cursor: pointer;
}

.visual-footer .nav-item img {
    width: 30px;
    height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/footToolbar.vue